import packageProviderService from '../services/settings/ppoints/PackageProviderService';

const prefetchQueries = async () => {
    await packageProviderService.getAllCached();
};

export const QueryUtils = { prefetchQueries };
